import { render, staticRenderFns } from "./SettingField.vue?vue&type=template&id=c539a078&scoped=true&lang=pug&"
import script from "./SettingField.vue?vue&type=script&lang=js&"
export * from "./SettingField.vue?vue&type=script&lang=js&"
import style0 from "./SettingField.vue?vue&type=style&index=0&id=c539a078&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c539a078",
  null
  
)

export default component.exports